import { useTranslation } from "react-i18next";

import Plus from "../../assets/img/icons/plus_primary.svg";
import CreateProjectDropdown from "../../components/DropdownStyle/CreateProjectDropdown";
import Select from "../../components/ReactSelectDropdown";
import { filterOption } from "../../components/ReactSelectDropdown/ReactSelectDropdown";
import { ButtonIcon } from "../../styledComponents/buttons";
import {
  CommonFlex,
  CommonGrid,
  CommonText,
  FormAlert,
  InputField,
  InputLabel,
  InputTextArea,
  InputWithLabelSection,
  RedStar,
} from "../../styledComponents/common";
import { InputSection } from "../Jobs/CreateJob/createTaskStyles";
import HelperIcon from "components/HelperIcon/HelperIcon";

const JobInputSection = ({
  // State values
  jobName,
  jobNumber,
  selectedWorkOrder,
  workOrderOptions,
  selectedClient,
  clientOptions,
  taskDescription,
  // Handlers
  onTaskNameChange,
  onJobNumberChange,
  onWorkOrderChange,
  onTaskDescriptionChange,
  handleProjectModalToggle,
  onClientChange,
  onAddCustomer,
  // Refs
  scrollName,
  scrollDescription,
  jobInputRef,
  // Other props
  orgType,
  saveErrors,
  mode, // "create" or "edit"
}) => {
  const { t } = useTranslation();
  
  // Generate labels based on orgType
  const isOperationType = orgType === "operation";
  const itemNameLabel = isOperationType ? t("task_name") : t("job_name");
  const jobNoLabel = isOperationType ? t("task_no") : t("job_no");
  const typeItemNameLabel = isOperationType
    ? t("type_task_name")
    : t("type_job_name");
  const workOrderLabel = t("project");
  const selectWorkOrderLabel = t("select_project");

  return (
    <InputSection responsiveBreakpoint="600px" responsiveColumns="1fr">
      <InputWithLabelSection ref={scrollName}>
        <InputLabel>
          {itemNameLabel} <RedStar>*</RedStar>
        </InputLabel>
        <InputField
          type="text"
          placeholder={typeItemNameLabel}
          ref={jobInputRef}
          value={jobName}
          onChange={e => onTaskNameChange(e)}
          style={
            saveErrors &&
            saveErrors[`jobName`] && {
              border: `1px solid #fe5969`,
              backgroundColor: `rgba(252, 87, 104, 0.05)`,
            }
          }
        />
        {saveErrors && saveErrors["jobName"] && (
          <FormAlert>{saveErrors["jobName"]}</FormAlert>
        )}
      </InputWithLabelSection>
      <InputWithLabelSection>
        <InputLabel>{jobNoLabel}</InputLabel>
        <InputField
          type="text"
          value={jobNumber}
          onChange={e => onJobNumberChange(e)}
        />
      </InputWithLabelSection>

      {orgType === "service" ? (
        <InputWithLabelSection>
           <CommonGrid columns="1fr 1fr">
            <InputLabel>
              {t("customer")} <RedStar>*</RedStar>
            </InputLabel>
            {mode !== "edit" &&<CommonText
              fontSize="13px"
              color="#2266EF"
              margin="0 0 0 0"
              fontWeight="550"
              style={{ cursor: "pointer", textAlign: "right" }}
              onClick={() => {
                if (onAddCustomer) onAddCustomer();
              }}
            >
              <ButtonIcon src={Plus} alt="plus" /> {t("add_customer")}
            </CommonText>}
          </CommonGrid>

          <Select
            isSearchable
            value={selectedClient}
            options={clientOptions || []}
            placeholder={t("select_customer")}
            onChange={e => {
              if (onClientChange) onClientChange(e);
            }}
            styles={CreateProjectDropdown({
              error: saveErrors && saveErrors["selectedClient"],
            })}
            filterOption={filterOption}
             isDisabled={mode === "edit"}
          />
          {saveErrors && saveErrors["selectedClient"] && (
            <FormAlert>{saveErrors["selectedClient"]}</FormAlert>
          )}
        </InputWithLabelSection>
      ) : null}

      {orgType !== "service" && (
        <InputWithLabelSection>
          <CommonGrid columns="1fr 1fr">
            <InputLabel>
              {workOrderLabel} <RedStar>*</RedStar>
            </InputLabel>
            {mode !== "edit" && (
              <CommonText
                fontSize="13px"
                color="#2266EF"
                margin="0 0 0 0"
                fontWeight="550"
                style={{ cursor: "pointer", textAlign: "right" }}
                onClick={() => {
                  handleProjectModalToggle();
                }}
              >
                <ButtonIcon src={Plus} alt="plus" /> Add {workOrderLabel}
              </CommonText>
            )}
          </CommonGrid>

          <Select
            isSearchable
            value={selectedWorkOrder}
            options={workOrderOptions}
            placeholder={selectWorkOrderLabel}
            onChange={e => {
              onWorkOrderChange(e);
            }}
            isDisabled={mode === "edit"}
            styles={CreateProjectDropdown()}
            filterOption={filterOption}
          />
          {saveErrors && saveErrors["selectedWorkOrder"] && (
            <FormAlert>{saveErrors["selectedWorkOrder"]}</FormAlert>
          )}
        </InputWithLabelSection>
      )}

      <InputWithLabelSection
        style={{ gridColumn: `1 / span 2` }}
        ref={scrollDescription}
      >
        <CommonFlex  disableResponsive={true} gap="4px">
        <InputLabel>{t("description")}</InputLabel>
        <HelperIcon
          text={t(
            "provide_a_description_for_the_task_or_job_or_add_any_instructions_you_may_have_for_your_members",
            { type: isOperationType ? t("task") : t("job") }
          )}
        />
        </CommonFlex>
        <InputTextArea
          text="Description"
          cols="35"
          rows="5"
          value={taskDescription}
          placeholder={t("type_description_here")}
          onChange={e => onTaskDescriptionChange(e)}
          height="auto"
          style={
            saveErrors &&
            saveErrors[`taskDescription`] && {
              border: `1px solid #fe5969`,
              backgroundColor: `rgba(252, 87, 104, 0.05)`,
            }
          }
        />
        {saveErrors &&
          saveErrors["taskDescription"] &&
          saveErrors["taskDescription"] !== undefined && (
            <FormAlert>{saveErrors["taskDescription"]}</FormAlert>
          )}
      </InputWithLabelSection>
    </InputSection>
  );
};

export default JobInputSection;
